<template>
  <div>
    <Form ref="form" @success="getList"/>
    <FilterForm :fields="searchFields" @submit="search" />
    <BasicTable
      border
      hasOperate
      customClass="table"
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns"
      :pageSize="+pageOption.per_page"
      :currentPage="+pageOption.current_page"
      :total="+pageOption.total"
      :loading="loading"
      @pageChange="pageChange"
    >
      <template slot="tableOpeate">
        生产厂商&emsp;
        <AppButton size="small" type="primary" plain @click="addManufacturer">
          <i class="fa fa-plus fa-lg icon"></i>新增
        </AppButton>&emsp;
      </template>
      <template v-slot:operate="{ item }">
        <AppButton size="small" type="primary" plain @click="editManufacturer(item)">编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteItem(item)">
          <i class="fa fa-trash-o fa-lg icon"></i>删除
        </AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { ManufacturerService } from '../../service/manufacturer.service';
import Form from "./formManufacturer.vue";
import { MessageBox } from 'element-ui';
const columns = [
  { name: '厂商名称', key: 'name' },
  { name: '操作', key: 'operate', type: 'custom' }
];
const searchFields = [
  { name: '厂商名称', key: 'name', type: 'input' },
];
export default {
  name: "manufacturer",
  components: { Form },
  data() {
    return {
      searchFields,
      searchValues: {},
      tableData: [],
      columns,
      loading: false,
      pageOption: {
        total: 0,
        current_page: 1,
        per_page: 20,
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const data = await ManufacturerService.getList({ rows: this.pageOption.per_page, page: this.pageOption.current_page, ...this.searchValues });
      this.loading = false;
      this.tableData = data.data;
      this.pageOption = data;
    },
    addManufacturer() {
      this.$refs.form.open('add');
    },
    editManufacturer(data) {
      this.$refs.form.open('edit', data);
    },
    deleteItem(data) {
      MessageBox.confirm('确定要删除这条这个厂商吗？\n删除之后名下产品会变更为无厂家状态。', '删除厂商').then(async () => {
        await ManufacturerService.deleteItem(data.id);
        this.getList();
      });
    },
    search(data) {
      this.searchValues = data;
      this.getList();
    },
    pageChange(index) {
      this.pageOption.current_page = index;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>